import script from "./StaffHeatmapCard.vue?vue&type=script&setup=true&lang=js"
export * from "./StaffHeatmapCard.vue?vue&type=script&setup=true&lang=js"

import "./StaffHeatmapCard.vue?vue&type=style&index=0&id=e9010ed8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e9010ed8"]])

export default __exports__